import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {getWebComponentInstance} from "fg-frontend/src/webComponents/decorate";
import {execute} from "fg-frontend/src/partialUpdate/partialUpdate";

const fragments = {
	DELIVERY_METHOD: '[data-fragment="OrderDelivery.deliveryMethodInput"]',
	DELIVERY_METHOD_CHECKED: '[data-fragment="OrderDelivery.deliveryMethodInput"]:checked',
	SUPPLEMENTARY_DELIVERY_METHOD: '[data-fragment="OrderDelivery.supplementaryDeliveryMethod"]',
	SUPPLEMENTARY_DELIVERY_METHOD_CHECKED: '[data-fragment="OrderDelivery.supplementaryDeliveryMethod"]:checked',
	AGENT: '[data-fragment="OrderDelivery.agent"]',
	E_PRODUCT_SPECIFIC_DATE: '[data-fragment="OrderDelivery.eProductSpecificDate"]',
	ORDER_PICKUP_INPUT: '[data-fragment="OrderPickupSLPosta.input"]',
};

class OrderDelivery extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
	}

	didMount() {
		const {
			commitClass,
		} = this.props;

		this.commitClass = commitClass;

		this.on('change', fragments.DELIVERY_METHOD,this.handleChangeStatus);
		this.on('change', fragments.SUPPLEMENTARY_DELIVERY_METHOD, this.handleCommit);
		$(fragments.AGENT).on('change', this.handleCommit);
		$(fragments.AGENT).on('select2:selecting', (e) => {
			e.target.classList.add('toCommit');
		});
		this.on('change', fragments.E_PRODUCT_SPECIFIC_DATE, this.handleCommit);
		this.orderPickupInput = this.element.querySelector(fragments.ORDER_PICKUP_INPUT);
		if(this.orderPickupInput) {
			this.orderPickupInput.addEventListener('change', this.handleCommit);
		}

		this.deliveryMethodElement = this.element.querySelector(fragments.DELIVERY_METHOD);
		this.agentSelectElement = this.element.querySelector(fragments.AGENT);
		this.eProductSpecificDate = this.element.querySelector(fragments.E_PRODUCT_SPECIFIC_DATE);

		this.submitButton = document.querySelector('#next');
		this.submitButton.addEventListener('click', this.commitChanges);

		const universalPreloaderComponentElement = document.getElementById('universalPreloader');
		this.universalPreloaderComponent = getWebComponentInstance(universalPreloaderComponentElement);

		// Otevření widgetu dle defaultních hodnot
		let deliveryMethodDefaultValue = document.querySelector('input[name="frm.deliveryMethod"]:checked');
		if(deliveryMethodDefaultValue != null) {
			this.handleChangeStatus(deliveryMethodDefaultValue);
		}
		// Automatické zvolení widgetu pokud je pouze jedna možnost
		// let deliveryMethodOnlyOne = document.querySelectorAll('input[name="frm.deliveryMethod"]');
		// if(deliveryMethodOnlyOne.length === 1) {
		// 	deliveryMethodOnlyOne[0].click();
		// }

		// Doplnkove kurierske sluzby radio uncheck
		this.on('click', fragments.SUPPLEMENTARY_DELIVERY_METHOD, this.handleClickOnSupplementaryDeliveryMethod);
	}

	handleClickOnSupplementaryDeliveryMethod = (e) => {
		let checkedElement = document.querySelector('input[name="frm.supplementaryDeliveryMethod"].active');
		if(e.target.classList.contains('active')){
			e.target.classList.remove('active');
			e.target.checked = false;
			this.element.querySelector('input[name="frm.supplementaryDeliveryMethod"]').click();
		} else {
			e.target.checked = true;
			e.target.classList.add('active');
		}
		if(checkedElement && e.target !== checkedElement) {
			checkedElement.classList.remove('active');
		}
	};

	handleCommit = (e) => {
		if(e.target) {
			e.target.classList.add('toCommit');
		}
		if(e.isTrusted) {
			e.preventDefault();
		}
		this.commitChanges(e);
	};


	/**
	 *	Zobrazovani widgetu pod aktivnim radkem
	 */
	handleChangeStatus = (e) => {
		let deliverySubContainer = document.querySelectorAll('.order-delivery-method__sub-container');
		for(let i = 0; i < deliverySubContainer.length; i++) {
			deliverySubContainer[i].classList.add('hidden');
		}
		let parentTrElement;
		if(typeof(e.target) !== 'undefined') {
			parentTrElement = e.target.parentElement.parentElement.parentElement;
		} else {
			parentTrElement = e.parentElement.parentElement.parentElement;
		}
		let parentTrElementNext = parentTrElement.nextElementSibling;
		if(parentTrElementNext != null && parentTrElementNext.classList.contains('order-delivery-method__sub-container')){
			do {
				parentTrElementNext.classList.remove('hidden');
				parentTrElementNext = parentTrElementNext.nextElementSibling;
			}
			while(parentTrElementNext != null && parentTrElementNext.classList.contains('order-delivery-method__sub-container'));
		}
		this.handleCommit(e);
	};
	/**
	 *	Získání csrf token z formuláře
	 */
	getCsrfToken = () => {
		return document.querySelector('form[id^=orderRecord] input[name=csrf]').value;
	};

	/**
	 *	Získání formId z formuláře
	 */
	getFormId = () => {
		return document.querySelector('form[id^=orderRecord] input[name=formId]').value;
	};
	/**
	 *	Odeslání volby doručení na server
	 */
	commitChanges = (e) => {
		let toCommitElements = document.querySelectorAll('.toCommit');
		let dataJSON = [];
		let _self = this;
		if(toCommitElements.length > 0) {
			for (let i = 0; i < toCommitElements.length; i++) {

				let branchId =  null;
				let branchIdElement = document.querySelector('.table .cursor-pointer.active');
				if(branchIdElement) {
					branchId = branchIdElement.getAttribute('data-filter-row-id');
				} else {
					branchIdElement = document.querySelector('input[name="filterRowId"]');
					if(branchIdElement) {
						branchId = branchIdElement.getAttribute('value');
					}
				}
				let deliveryMethod =  null;
				this.deliveryMethodElement = this.element.querySelector(fragments.DELIVERY_METHOD_CHECKED);
				if(this.deliveryMethodElement){
					deliveryMethod = this.deliveryMethodElement.value;
				}
				let courierServices = null;
				this.supplementaryDeliveryMethodElement = this.element.querySelector(fragments.SUPPLEMENTARY_DELIVERY_METHOD_CHECKED);
				if(this.supplementaryDeliveryMethodElement){
					courierServices = this.supplementaryDeliveryMethodElement.value;
				}
				let eProductSpecificDate =  null;
				if(this.eProductSpecificDate) {
					eProductSpecificDate = this.eProductSpecificDate.value;
				}
				// let personalPickUpBranch =  null;
				// if(this.agentSelectElement) {
				// 	personalPickUpBranch = this.agentSelectElement.value;
				// }
				let pickUpPointId = null;
				let orderPickupSLPostaInput = this.element.querySelector(fragments.ORDER_PICKUP_INPUT);
				if(orderPickupSLPostaInput) {
					pickUpPointId = orderPickupSLPostaInput.value;
				}
				let orderPickupSLPosta = this.element.querySelector("#orderPickupSLPosta");
				let pickUpPointName = null;
				let pickUpPointAddress = null;
				if(orderPickupSLPosta) {
					pickUpPointName = orderPickupSLPosta.dataset.name ? orderPickupSLPosta.dataset.name : null;
					pickUpPointAddress = orderPickupSLPosta.dataset.address ? orderPickupSLPosta.dataset.address : null;
				}

				dataJSON.push({
					branchId: branchId,
					deliveryMethod: deliveryMethod,
					courierServices: courierServices,
					pickUpPointId: pickUpPointId,
					pickUpPointName: pickUpPointName,
					pickUpPointAddress: pickUpPointAddress,
					eproductSpecificDate: eProductSpecificDate,
				});
				this.universalPreloaderComponent.handleOn(10);
				let commitUrl = window.location.pathname + '?formId=' + this.getFormId() + '&csrf=' + this.getCsrfToken() + '&eventName.storeOrderDelivery:orderRecord=';
				let xmlHttpReq = new XMLHttpRequest();
				xmlHttpReq.open('POST', commitUrl, true);
				xmlHttpReq.setRequestHeader("Content-Type", "application/json");
				xmlHttpReq.onreadystatechange = function () {
					if (xmlHttpReq.readyState === 4) {
						if (xmlHttpReq.status === 200) {
							let data = JSON.parse(xmlHttpReq.responseText);
							console.log("onreadystatechange to server - " + data.ok);
							if (data.ok) {
								for(i = 0; i <toCommitElements.length; i++){
									toCommitElements[i].classList.remove(_self.commitClass);
								}
								execute({
									url: _self.href,
									target: 'productNominalTotalSum',
								});
							}
						}
					}
					_self.universalPreloaderComponent.handleOff(10);
				};
				xmlHttpReq.send(JSON.stringify(dataJSON));
			}
		}
	};
}

OrderDelivery.defaultProps = {
	commitClass: 'toCommit',
};

export default OrderDelivery;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/OrderDelivery.js